/**
 * Componente StatusMessage reutilizable
 * Para mostrar mensajes de éxito, error, loading, etc.
 */

import React from 'react';
import PropTypes from 'prop-types';
import { FaCheckCircle, FaExclamationCircle, FaSpinner, FaInfoCircle } from 'react-icons/fa';

const StatusMessage = ({
  type,
  message,
  className = ''
}) => {
  if (!type || !message) return null;

  const config = {
    success: {
      icon: FaCheckCircle,
      bgColor: 'bg-green-100',
      textColor: 'text-green-800',
      iconColor: 'text-green-500',
      borderColor: 'border-green-200'
    },
    error: {
      icon: FaExclamationCircle,
      bgColor: 'bg-red-100',
      textColor: 'text-red-800',
      iconColor: 'text-red-500',
      borderColor: 'border-red-200'
    },
    loading: {
      icon: FaSpinner,
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-800',
      iconColor: 'text-blue-500',
      borderColor: 'border-blue-200',
      animate: true
    },
    info: {
      icon: FaInfoCircle,
      bgColor: 'bg-blue-100',
      textColor: 'text-blue-800',
      iconColor: 'text-blue-500',
      borderColor: 'border-blue-200'
    },
    warning: {
      icon: FaExclamationCircle,
      bgColor: 'bg-yellow-100',
      textColor: 'text-yellow-800',
      iconColor: 'text-yellow-500',
      borderColor: 'border-yellow-200'
    }
  };

  const currentConfig = config[type] || config.info;
  const Icon = currentConfig.icon;

  return (
    <div 
      className={`
        flex items-center gap-3 p-4 rounded-lg border
        ${currentConfig.bgColor}
        ${currentConfig.textColor}
        ${currentConfig.borderColor}
        ${className}
      `}
      role={type === 'error' ? 'alert' : 'status'}
    >
      <Icon 
        className={`
          w-5 h-5 flex-shrink-0
          ${currentConfig.iconColor}
          ${currentConfig.animate ? 'animate-spin' : ''}
        `} 
      />
      <span className="font-medium">{message}</span>
    </div>
  );
};

StatusMessage.propTypes = {
  type: PropTypes.oneOf(['success', 'error', 'loading', 'info', 'warning']),
  message: PropTypes.string,
  className: PropTypes.string
};

export default StatusMessage;
